export const environment = {
  production: false,
  PARSE_APP_ID: '10vOppRB5jS8rO3wWerIsThHMbcfzl4mOnk2XQOx',
  PARSE_JS_KEY: 'p7VwyMt6X3XI843cEwJwktiOoq3EYKpZaQPTVNsW',
  serverURL: 'https://parseapi.back4app.com',
  // serverURL: 'http://localhost:1337/parse',
  gmap: 'AIzaSyBvXRT1UnZ4x0tPusv91I0LXFZq9iY1-1A'
};